import { generateURL } from 'utils/helpers';

const reservation = {
  packagesCreate: (params) => {
    const url = generateURL('/reservation/packages/create');

    if (typeof fbq !== 'undefined' && fbq) {
      fbq('track', 'InitiateCheckout');
    }

    return fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    }).then((response) => {
      if (response.status > 299) {
        const error = new Error('Failed to create reservation');
        error.code = response.status;
        return Promise.reject(error);
      }
      return response.json();
    });
  },

  create: (params) => {
    const url = generateURL('/reservation/create');

    if (typeof fbq !== 'undefined' && fbq) {
      fbq('track', 'InitiateCheckout');
    }

    return fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    }).then((response) => {
      if (response.status > 299) {
        return Promise.reject(new Error('Failed to create reservation'));
      }
      return response.json();
    });
  },

  delete: (bookingId, reservationId) => {
    const url = generateURL(
      `/booking/${bookingId}/reservation/${reservationId}`
    );
    return fetch(url, {
      method: 'DELETE',
    }).then((response) => {
      if (response.status > 299) {
        return Promise.reject(
          new Error(`Failed to delete reservation#${reservationId}`)
        );
      }
      return response.json();
    });
  },

  createScheduledTrip: (params) => {
    const url = generateURL('/reservation/scheduled_trip/create');
    const message = 'Failed to create reservation. Please try again.';

    if (typeof fbq !== 'undefined' && fbq) {
      fbq('track', 'InitiateCheckout');
    }

    return fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    })
      .then((response) => {
        if (response.status > 299 && response.status !== 422) {
          return Promise.reject(new Error(message));
        }
        return response.json();
      })
      .then((json) => {
        if (json.status === 422) {
          return Promise.reject(new Error(json.message || message));
        }
        return json;
      });
  },

  findServices: (params, signal) => {
    const url = generateURL('/reservation/scheduled_trips/find');

    return fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
      signal,
    }).then((response) => {
      if (response.status > 299) {
        return Promise.reject(new Error('Failed to find scheduled trips '));
      }
      return response.json();
    });
  },

  // TODO: Move this to availability.js?
  findCalendarServices: (params, signal) => {
    const url = generateURL(
      '/reservation/scheduled_trips/calendar_availability'
    );

    return fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
      signal,
    }).then((response) => {
      if (response.status > 299) {
        return Promise.reject(
          new Error('Failed to fetch calendar availability')
        );
      }
      return response.json();
    });
  },

  getRouteByID: (id) => {
    const url = generateURL(`/routes/?ids[]=${id}`);

    return fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }).then((response) => {
      if (response.status > 299) {
        return Promise.reject(new Error('Failed to find scheduled trips '));
      }
      return response.json();
    });
  },

  bulkUpdate: (reservations) => {
    const url = generateURL('/reservation/scheduled_trips/bulk_update');

    return fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ reservations }),
    }).then((response) => {
      if (response.status !== 200) {
        const error = new Error('Failed to update the reservation');
        error.response = response.json();
        return Promise.reject(error);
      }
      return response.json();
    });
  },

  createAccomodation: (params) => {
    const url = generateURL('/reservation/accommodation/upsert');

    if (typeof fbq !== 'undefined' && fbq) {
      fbq('track', 'InitiateCheckout');
    }

    return fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    }).then((response) => {
      if (response.status > 299) {
        return Promise.reject(new Error('Failed to create reservation'));
      }
      return response.json();
    });
  },
};

export default reservation;
